import React, { useState } from 'react';
import BookingModal from '../components/BookingModal';

export default function Services() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-ayurveda-green-dark to-ayurveda-green text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl sm:text-5xl font-heading font-bold mb-4">
            Our Ayurvedic Services
          </h1>
          <div className="mx-auto h-1 w-24 bg-ayurveda-gold rounded mb-4"></div>
          <p className="text-xl text-gray-100 max-w-3xl mx-auto">
            Comprehensive holistic treatments to restore balance, vitality, and wellness
          </p>
        </div>
      </section>

      {/* Kshar Sutra Therapy */}
      <section id="kshar-sutra" className="section-container bg-white scroll-mt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-ayurveda-green-light rounded-full mb-4">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
              </svg>
            </div>
            <h2 className="text-3xl font-heading font-bold text-ayurveda-green-dark mb-4">
              Kshar Sutra Therapy
            </h2>
            <p className="text-lg text-gray-600 mb-4">
              For Piles, Fistula, and Fissure
            </p>
            <div className="h-1 w-20 bg-ayurveda-gold rounded mb-6"></div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Kshar Sutra</strong> is a traditional Ayurvedic parasurgical treatment specifically 
                designed for anorectal disorders such as hemorrhoids (piles), anal fistulas, and fissures. 
                This time-tested procedure uses a medicated herbal thread to gradually cut through and heal 
                diseased tissue.
              </p>

              <div className="bg-ayurveda-green-light p-6 rounded-xl my-6">
                <h3 className="font-bold text-ayurveda-green-dark mb-3 flex items-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  Key Benefits
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start gap-2">
                    <span className="text-ayurveda-green-dark mt-1">•</span>
                    <span><strong>Non-Surgical:</strong> No incisions or conventional surgery required</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-ayurveda-green-dark mt-1">•</span>
                    <span><strong>High Success Rate:</strong> Proven effective for lasting relief</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-ayurveda-green-dark mt-1">•</span>
                    <span><strong>Minimal Recovery:</strong> Less downtime compared to surgery</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-ayurveda-green-dark mt-1">•</span>
                    <span><strong>Natural Healing:</strong> Uses alkaline herbs for purification and infection prevention</span>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-ayurveda-green-dark mb-3">How It Works</h3>
                <p>
                  The medicated Kshar Sutra thread is carefully applied to the affected area. The thread 
                  contains herbal preparations with alkaline properties that help cut through the tissue 
                  while simultaneously promoting healing and preventing infection. The thread is changed 
                  weekly until the tissue is completely cut through and healed.
                </p>
              </div>

              <div className="bg-ayurveda-gold-light p-6 rounded-xl border-l-4 border-ayurveda-gold">
                <p className="font-semibold text-ayurveda-green-dark">
                  We deliver lasting relief from piles, fistulas, and fissures through Kshar Sutra's proven methods.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="/kshar-sutra.jpg" 
              alt="Kshar Sutra Therapy" 
              className="rounded-3xl shadow-2xl object-cover w-full h-[500px]"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><rect fill="%23E8F5E9" width="800" height="600"/><text x="50%" y="50%" font-size="24" text-anchor="middle" fill="%234CAF50" font-family="sans-serif">Kshar Sutra Treatment</text></svg>';
              }}
            />
          </div>
        </div>
      </section>

      {/* Neurotherapy & Nadi Parikshan */}
      <section id="neurotherapy" className="section-container bg-ayurveda-green-light scroll-mt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <img 
              src="/neurotherapy.jpg" 
              alt="Neurotherapy" 
              className="rounded-3xl shadow-2xl object-cover w-full h-[500px]"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><rect fill="%23FFE0B2" width="800" height="600"/><text x="50%" y="50%" font-size="24" text-anchor="middle" fill="%23795548" font-family="sans-serif">Neurotherapy Session</text></svg>';
              }}
            />
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h2 className="text-3xl font-heading font-bold text-ayurveda-green-dark mb-4">
              Neurotherapy & Nadi Parikshan
            </h2>
            <p className="text-lg text-gray-600 mb-4">
              Drug-Free Nerve Therapy & Pulse Diagnosis
            </p>
            <div className="h-1 w-20 bg-ayurveda-gold rounded mb-6"></div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Neurotherapy</strong> is a drug-free, hands-on therapy rooted in Vedic principles. 
                It targets the nervous system by applying controlled pressure and therapeutic massage to specific 
                nerve channels, helping restore the body's internal harmony and natural healing abilities.
              </p>

              <div>
                <h3 className="font-bold text-ayurveda-green-dark mb-3">Nadi Parikshan (Pulse Diagnosis)</h3>
                <p>
                  Our practitioners use this ancient diagnostic technique to assess your unique constitution 
                  and identify imbalances by reading the subtle signals in your pulse. This personalized 
                  assessment guides customized treatment plans.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl my-6">
                <h3 className="font-bold text-ayurveda-green-dark mb-3 flex items-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                  How Neurotherapy Works
                </h3>
                <p>
                  The therapist applies controlled pressure (often using hands or elbows) along specific nerve 
                  pathways to activate or calm organs. This improves nerve conduction, blood flow, and lymphatic 
                  drainage, helping rebalance the body's systems naturally.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl">
                <h3 className="font-bold text-ayurveda-green-dark mb-3">Conditions Treated</h3>
                <div className="grid md:grid-cols-2 gap-3">
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Stroke & Paralysis
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Migraine & Headaches
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Nerve Pain & Sciatica
                    </li>
                  </ul>
                  <ul className="space-y-2 text-sm">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Spondylitis (Spinal Arthritis)
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Joint Disorders & Arthritis
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 bg-ayurveda-green rounded-full"></span>
                      Muscular Issues
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-ayurveda-gold-light p-6 rounded-xl border-l-4 border-ayurveda-gold">
                <p className="font-semibold text-ayurveda-green-dark">
                  Safe & Gentle: No injections or drugs, only therapeutic touch and pressure therapy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Panchakarma */}
      <section id="panchakarma" className="section-container bg-white scroll-mt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-ayurveda-green-light rounded-full mb-4">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>
            <h2 className="text-3xl font-heading font-bold text-ayurveda-green-dark mb-4">
              Panchakarma Detox Therapy
            </h2>
            <p className="text-lg text-gray-600 mb-4">
              Comprehensive Cleanse & Rejuvenation
            </p>
            <div className="h-1 w-20 bg-ayurveda-gold rounded mb-6"></div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                <strong>Panchakarma</strong> (literally "five actions") is an intensive Ayurvedic cleansing 
                and rejuvenation program. This personalized regimen of therapies is designed to eliminate 
                deep-rooted toxins (ama) and restore the balance of your doshas for optimal health.
              </p>

              <div className="bg-ayurveda-green-light p-6 rounded-xl my-6">
                <h3 className="font-bold text-ayurveda-green-dark mb-3">The Three Phases</h3>
                <ol className="space-y-3">
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-ayurveda-green text-white rounded-full flex items-center justify-center text-sm font-bold">1</span>
                    <div>
                      <strong>Purvakarma (Preparation):</strong> Oil massages (Snehan) and steam therapy 
                      (Swedana) to loosen toxins
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-ayurveda-green text-white rounded-full flex items-center justify-center text-sm font-bold">2</span>
                    <div>
                      <strong>Main Treatments:</strong> Core detox procedures like herbal purgation and 
                      medicated enemas
                    </div>
                  </li>
                  <li className="flex gap-3">
                    <span className="flex-shrink-0 w-6 h-6 bg-ayurveda-green text-white rounded-full flex items-center justify-center text-sm font-bold">3</span>
                    <div>
                      <strong>Paschatkarma (Post-Care):</strong> Gentle diet, herbal tonics, and rejuvenation 
                      practices
                    </div>
                  </li>
                </ol>
              </div>

              <div className="bg-white border-2 border-ayurveda-green p-6 rounded-xl">
                <h3 className="font-bold text-ayurveda-green-dark mb-4 text-center">Key Benefits</h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Deep Detoxification:</strong> Purifies at cellular level</span>
                  </div>
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Enhanced Digestion:</strong> Balances digestive fire</span>
                  </div>
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Mental Clarity:</strong> Sharpens mind and focus</span>
                  </div>
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Increased Vitality:</strong> Restores energy and vigor</span>
                  </div>
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Stronger Immunity:</strong> Builds natural defenses</span>
                  </div>
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-ayurveda-green flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    <span className="text-sm"><strong>Chronic Relief:</strong> Helps skin, hormonal issues</span>
                  </div>
                </div>
              </div>

              <div className="bg-ayurveda-gold-light p-6 rounded-xl">
                <p className="text-sm">
                  <strong>Holistic Care:</strong> Our Panchakarma programs include a carefully monitored diet 
                  of nutritious, light foods (khichdi, steamed vegetables) and herbal tonics to help your body 
                  heal and regain balance.
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="/panchakarma.jpg" 
              alt="Panchakarma Therapy" 
              className="rounded-3xl shadow-2xl object-cover w-full h-[600px]"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 700"><rect fill="%23E8F5E9" width="800" height="700"/><text x="50%" y="50%" font-size="24" text-anchor="middle" fill="%234CAF50" font-family="sans-serif">Panchakarma Detox</text></svg>';
              }}
            />
          </div>
        </div>
      </section>

      {/* Herbal Consultation */}
      <section id="herbal" className="section-container bg-ayurveda-brown-light scroll-mt-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1">
            <img 
              src="/herbal-medicine.jpg" 
              alt="Herbal Medicine" 
              className="rounded-3xl shadow-2xl object-cover w-full h-[500px]"
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 600"><rect fill="%23EFEBE9" width="800" height="600"/><text x="50%" y="50%" font-size="24" text-anchor="middle" fill="%23795548" font-family="sans-serif">Herbal Medicines</text></svg>';
              }}
            />
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full mb-4">
              <svg className="w-8 h-8 text-ayurveda-green-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <h2 className="text-3xl font-heading font-bold text-ayurveda-green-dark mb-4">
              Herbal Consultation & Medicines
            </h2>
            <p className="text-lg text-gray-600 mb-4">
              Personalized Natural Remedies
            </p>
            <div className="h-1 w-20 bg-ayurveda-gold rounded mb-6"></div>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <div>
                <h3 className="font-bold text-ayurveda-green-dark mb-3">Personalized Ayurvedic Care</h3>
                <p>
                  Our consultations include a thorough evaluation – taking your medical history, performing 
                  pulse diagnosis (Nadi Parikshan), and assessing your lifestyle. This helps us identify your 
                  unique dosha imbalances and create a customized treatment plan.
                </p>
              </div>

              <div className="bg-white p-6 rounded-xl my-6">
                <h3 className="font-bold text-ayurveda-green-dark mb-3 flex items-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                  100% Natural Herbal Formulas
                </h3>
                <p>
                  All our medicines are prepared from traditional herbs following authentic Ayurvedic formulations. 
                  These natural remedies are designed to support your body's own healing processes with minimal 
                  side effects.
                </p>
              </div>

              <div className="space-y-3">
                <h3 className="font-bold text-ayurveda-green-dark">Our Herbal Medicines Help With:</h3>
                <div className="grid gap-2">
                  <div className="flex items-center gap-3 bg-white p-3 rounded-lg">
                    <span className="w-2 h-2 bg-ayurveda-green rounded-full"></span>
                    <span className="text-sm"><strong>Immunity Boost:</strong> Strengthen natural defenses</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white p-3 rounded-lg">
                    <span className="w-2 h-2 bg-ayurveda-green rounded-full"></span>
                    <span className="text-sm"><strong>Digestive Health:</strong> Improve gut function and metabolism</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white p-3 rounded-lg">
                    <span className="w-2 h-2 bg-ayurveda-green rounded-full"></span>
                    <span className="text-sm"><strong>Blood Purification:</strong> Cleanse and detoxify naturally</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white p-3 rounded-lg">
                    <span className="w-2 h-2 bg-ayurveda-green rounded-full"></span>
                    <span className="text-sm"><strong>Enhanced Vitality:</strong> Increase energy and stamina</span>
                  </div>
                  <div className="flex items-center gap-3 bg-white p-3 rounded-lg">
                    <span className="w-2 h-2 bg-ayurveda-green rounded-full"></span>
                    <span className="text-sm"><strong>Stress Relief:</strong> Calm mind and reduce anxiety</span>
                  </div>
                </div>
              </div>

              <div className="bg-ayurveda-gold-light p-6 rounded-xl border-l-4 border-ayurveda-gold">
                <p className="font-semibold text-ayurveda-green-dark mb-2">Safe & Effective</p>
                <p className="text-sm">
                  Our herbal medicine preparations use pure ingredients to create remedies tailored for each 
                  patient's condition. Unlike many modern drugs, Ayurvedic herbs work in harmony with the body – 
                  bringing balance and wellness without harsh chemicals.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-container bg-gradient-to-r from-ayurveda-green-dark to-ayurveda-green text-white">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold mb-4">
            Start Your Healing Journey Today
          </h2>
          <p className="text-lg mb-8 text-gray-100">
            Experience personalized Ayurvedic care tailored to your unique needs. 
            Our expert practitioners are here to guide you to optimal health.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setIsBookingModalOpen(true)}
              className="bg-white text-ayurveda-green-dark hover:bg-gray-100 font-semibold py-3 px-8 rounded-lg transition shadow-lg"
            >
              Book Consultation
            </button>
            <a 
              href="tel:+919992009696"
              className="bg-ayurveda-gold hover:bg-orange-600 text-white font-semibold py-3 px-8 rounded-lg transition shadow-lg"
            >
              Call: 099920 09696
            </a>
          </div>
        </div>
      </section>

      {/* Booking Modal */}
      <BookingModal 
        isOpen={isBookingModalOpen} 
        onClose={() => setIsBookingModalOpen(false)} 
      />
    </div>
  );
}
